import { Control } from 'react-hook-form';
import IconLoader from '../icons/loader';
import SidepanelNumberRow from './sidepanel-number-row';
import { TransactionAML, TransactionTypeEnum } from './types';

import styles from './transaction.module.css';

interface AmlContentProps {
  aml?: TransactionAML;
  isLoading: boolean;
  control?: Control;
  transactionType: TransactionTypeEnum;
}

export default function IncomingOutgoingAmlContent({
  aml,
  isLoading,
  control,
  transactionType,
}: AmlContentProps): React.JSX.Element {
  let content;
  const enableEdit = Boolean(control);

  let contentCustomer;

  if (transactionType === TransactionTypeEnum.INCOMING) {
    contentCustomer = (
      <div className={styles.transactionBlockWrapper}>
        <div className={styles.transactionTitle}>Recipient Risk Score</div>
        <SidepanelNumberRow
          title="Total Recipient Risk Score"
          value={aml?.recipientRiskScore}
          name="recipientRiskScore"
          control={control}
          enableEdit={enableEdit}
          disabled
        />
      </div>
    );
  } else if (transactionType === TransactionTypeEnum.OUTGOING) {
    contentCustomer = (
      <div className={styles.transactionBlockWrapper}>
        <div className={styles.transactionTitle}>Sender Risk Score</div>
        <SidepanelNumberRow
          title="Total Customer Risk Score"
          value={aml?.senderRiskScore}
          name="senderRiskScore"
          control={control}
          enableEdit={enableEdit}
          disabled
        />
      </div>
    );
  } else if (transactionType === TransactionTypeEnum.INTERNAL) {
    contentCustomer = (
      <>
        <div className={styles.transactionBlockWrapper}>
          <div className={styles.transactionTitle}>Recipient Risk Score</div>
          <SidepanelNumberRow
            title="Total Recipient Risk Score"
            value={aml?.recipientRiskScore}
            name="recipientRiskScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
        </div>
        <div className={styles.transactionBlockWrapper}>
          <div className={styles.transactionTitle}>Sender Risk Score</div>
          <SidepanelNumberRow
            title="Total Sender Risk Score"
            value={aml?.senderRiskScore}
            name="senderRiskScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
        </div>
      </>
    );
  }

  if (isLoading) {
    content = (
      <div className={styles.loader}>
        <IconLoader className={styles.loaderIcon} />
      </div>
    );
  } else {
    content = (
      <>
        <div className={styles.transactionBlockWrapper}>
          <div className={styles.transactionTitle}>
            Weighted transaction score
          </div>
          <SidepanelNumberRow
            title="Weighted transaction score"
            value={aml?.totalRiskScore}
            name="totalRiskScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
        </div>
        {contentCustomer}
        {transactionType !== TransactionTypeEnum.INTERNAL && (
          <div className={styles.transactionBlockWrapper}>
            <div className={styles.transactionTitle}>
              Geographical Risk score
            </div>
            <SidepanelNumberRow
              title="Country of the counterparty Risk score"
              value={aml?.counterpartyCountryScore}
              name="counterpartyCountryScore"
              control={control}
              enableEdit={enableEdit}
              disabled
            />
            <SidepanelNumberRow
              title="Country of the bank of counterparty Risk score"
              value={aml?.counterpartyBankCountryScore}
              name="counterpartyBankCountryScore"
              control={control}
              enableEdit={enableEdit}
              disabled
            />
            <SidepanelNumberRow
              title="Total GEO Risk score"
              value={aml?.countryScore}
              name="countryScore"
              control={control}
              enableEdit={enableEdit}
              disabled
            />
          </div>
        )}
        <div className={styles.transactionBlockWrapper}>
          <div className={styles.transactionTitle}>Transaction Volume Risk</div>
          <SidepanelNumberRow
            title="Transaction volume (single transaction) Risk score"
            value={aml?.singleTransactionVolumeScore}
            name="singleTransactionVolumeScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
          <SidepanelNumberRow
            title="Transaction volume (multiple transactions) Risk score"
            value={aml?.multipleTransactionVolumeScore}
            name="multipleTransactionVolumeScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
          <SidepanelNumberRow
            title="Total Transaction Volume Risk score"
            value={aml?.transactionScore}
            name="transactionScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
        </div>
        <div className={styles.transactionBlockWrapper}>
          <div className={styles.transactionTitle}>
            Product/service Risk score
          </div>
          <SidepanelNumberRow
            title="Total Product/service Risk score"
            value={aml?.productScore}
            name="productScore"
            control={control}
            enableEdit={enableEdit}
            disabled
          />
        </div>
      </>
    );
  }

  return content;
}
